"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListCampaignsQuerySchema = exports.UpdateCampaignBodySchema = exports.CreateCampaignBodySchema = exports.UpdateCampaignResponseSchema = exports.CreateCampaignResponseSchema = exports.ListCampaignsResponseSchema = exports.GetCampaignResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
/**
 * Responses
 */
exports.GetCampaignResponseSchema = common_1.CampaignSchema;
exports.ListCampaignsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.CampaignSchema);
exports.CreateCampaignResponseSchema = common_1.CampaignSchema;
exports.UpdateCampaignResponseSchema = common_1.CampaignSchema;
/**
 * Body
 */
exports.CreateCampaignBodySchema = (0, core_1.StrictObject)({
    name: core_1.NameSchema,
    description: core_1.DescriptionSchema,
    objective: ruby_1.ObjectiveSchema,
    channelType: ruby_1.ChannelTypeSchema,
    status: ruby_1.CampaignStatusSchema,
});
exports.UpdateCampaignBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.Optional(core_1.NameSchema),
    description: typebox_1.Type.Optional(core_1.DescriptionSchema),
    objective: typebox_1.Type.Optional(ruby_1.ObjectiveSchema),
    status: typebox_1.Type.Optional(ruby_1.CampaignStatusSchema),
});
/**
 * Query parameters
 */
exports.ListCampaignsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
